var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { css, html, LitElement } from "lit";
import { property } from "lit/decorators.js";
import { FormControlMixin } from "../../../a2k-form-control/index.js";
export class A2kTextField extends FormControlMixin(LitElement) {
    constructor() {
        super(...arguments);
        this.defaultValue = "";
        this.name = "";
        this.label = "";
        this.placeholder = "";
    }
    static get formAssociated() {
        return true;
    }
    handleInputChange(e) {
        const target = e.target;
        this.setValue(target.value);
        const customEvent = new Event("change", { composed: true, bubbles: true });
        this.dispatchEvent(customEvent);
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.label) {
            this.label = `${this.label}:`;
        }
    }
    render() {
        return html `
      <div>
        <label for="input">${this.label}</label>
        <input
          id="input"
          name=${this.name}
          defaultValue=${this.defaultValue}
          placeholder=${this.placeholder}
          type="text"
          @input=${this.handleInputChange}
          @change=${this.handleInputChange}
        />
      </div>
    `;
    }
}
A2kTextField.styles = css `
    * {
      box-sizing: border-box;
      letter-spacing: var(--letter-spacing);
    }

    :host {
      display: block;
      width: 100%;
    }

    input {
      font-family: var(--font-primary);
      font-size: var(--text-field-font-size);
      padding-inline: var(--text-field-padding-inline);
      width: 100%;
      height: var(--text-field-height);
      border-top: var(--text-field-border-top);
      border-left: var(--text-field-border-left);
      border-bottom: var(--text-field-border-bottom);
      border-right: var(--text-field-border-right);
    }

    input::placeholder {
      font-family: var(--font-primary);
    }
  `;
__decorate([
    property(),
    __metadata("design:type", Object)
], A2kTextField.prototype, "defaultValue", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], A2kTextField.prototype, "name", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], A2kTextField.prototype, "label", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], A2kTextField.prototype, "placeholder", void 0);
